import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import styles from "./ViewFeedbackDetails.module.css";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import useModal from "../../../hooks/useModal";
import ShowResolverInfoModal from "../../basic-component/Modal/ShowResolverInfoModal";
import useAxiosFetchData from "../../../hooks/useAxiosFetchData";
import API_Routes from "../../../../constants/api-routes";
import { useSelector } from "react-redux";
import ViewFeedbackDetails from "./ViewFeedbackDetails";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import useDialog from "../../../hooks/useAddModal";
import { getCustomerFeedbackDetailsURL } from "../../../../constants/constants";

// Bootstrap
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { CardBody } from "react-bootstrap";
import { t } from "i18next";
import DatatTable from "../../basic-component/TableNoStyle";

export default function CustomerSatisfactionResponse({ data }) {
  const columnData = useMemo(
    () => [
      {
        accessorKey: "reason",
        header: t("general.label.rating"),
        enableRowSpan: true,
        size: 40,
      },
      {
        accessorKey: "time",
        header: t("Time"),
        enableRowSpan: true,
        size: 20,
      },
      {
        accessorKey: "rating",
        header: t("login.msg.reason"),
        size: 20,
      },
    ],
    [t]
  );
  const [reopenReasonList, setReopenReasonList] = useState([]);

  const [feedbackDescription, setFeedbackDescription] = useState("");

  const [selectedTaggedFeedbackId, setSelectedTaggedFeedbackId] =
    useState(null); // State for selected feedback ID
  const [showRate, setRate] = useState(false);
  const roles = useSelector((state) => state.role.userCurrRole.description);
  const rolesId = useSelector((state) => state.role.userCurrRole.id);
  const [showConsent, setShowConsent] = useState(true);
  // const [reopenReasonList, setReopenReasonList] = useState([]);
  const [showResolution, setshowResolution] = useState(true);

  useEffect(() => {
    // debugger
    if (data && data.feedbackDetails && data.feedbackDetails.user) {
      const stringifiedData = data;

      setFeedbackDescription(
        stringifiedData?.feedbackDetails?.description || ""
      );
      setReopenReasonList((prev) => stringifiedData?.reopenReasonList);
      console.log(reopenReasonList);
    } else if (data && data.feedbackDetails) {
      const stringifiedData = data;

      setReopenReasonList(
        stringifiedData?.reopenReasonList[0]?.feedbackSatisfaction
      );
    } else if (data && data.id) {
      const stringifiedData = data;
      // debugger
      setReopenReasonList(
        stringifiedData?.reopenReasonList[0]?.feedbackSatisfaction
      );
    }
    // debugger
    console.log(reopenReasonList);
  }, [data]);
  useEffect(() => {
    // if (reopenReasonList !== null && reopenReasonList !== undefined) {
    //   for (let i = 0; i < (reopenReasonList.id !== undefined ? reopenReasonList.id : 0); i++) {
    //     setStars((prev) => [...prev, (<i className="ti ti-star-filled orange-color icon-small fs-6 me-1" key={i}></i>)]);
    //   }
    // }
    // console.log(reopenReasonList);
    // debugger;
    reopenReasonList?.map((reason, index1) => {
      debugger;
      if (reason?.updateDate && !reason.updateDate.toString().includes('/')) {
        const date = new Date(reason.updateDate); // works with timestamp or ISO string
        if (!isNaN(date)) {
          const pad = (n) => n.toString().padStart(2, '0');
          const formattedDate = `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
          reason.updateDate = formattedDate;
        }
      }
      if (reason?.feedbackSatisfaction?.reason) {
        console.log(reason.feedbackSatisfaction.reason);
        console.log(reason.updateDate);
        // debugger;        

        if (typeof reason.feedbackSatisfaction.reason === "string") {
          console.log(reason.feedbackSatisfaction.reason);
          console.log(reason.feedbackSatisfaction.updateDate)
          try {
            console.log(reason.feedbackSatisfaction.reason);
            const parsedReason = JSON.parse(reason.feedbackSatisfaction.reason);
            const parsedTime = JSON.parse(reason.updateDate);
            console.log(parsedReason);
            if (Array.isArray(parsedReason)) {
              debugger;
              parsedReason.map((item, index) => {
                console.log(item);                
                debugger;
                rowsData.push({
                  rating: item.deSatisfactionReason,                  
                  time: item.updateDate,
                  reason: index === 0 && (
                    <button
                      type="button"
                      className="btn-rating after-rated py-1 lh-normal btn btn-secondary btn-sm m-0"
                    >
                      <span>
                        {reason?.feedbackSatisfaction?.id < 10 ? (
                          <>
                            {Array.from(
                              { length: reason?.feedbackSatisfaction?.id },
                              (_, i) => (
                                <i
                                  className={`ti ti-star-filled star-${reason?.feedbackSatisfaction?.id} icon-small fs-6`}
                                  key={i}
                                  //   onClick={handleCustomerSatisfactionStar}
                                ></i>
                              )
                            )}
                            {Array.from(
                              {
                                length:
                                  5 - (reason?.feedbackSatisfaction?.id || 0),
                              },
                              (_, j) => (
                                <i
                                  className={`ti ti-star star-${reason?.feedbackSatisfaction?.id} icon-small fs-6`}
                                  key={j}
                                  //   onClick={handleCustomerSatisfactionStar}
                                ></i>
                              )
                            )}
                          </>
                        ) : reason?.feedbackSatisfaction?.id === 100 ? (
                          <>
                            {Array.from({ length: 5 }, (_, i) => (
                              <i
                                className={`ti ti-star-filled star-5 icon-small fs-6`}
                                key={i}
                                // onClick={handleCustomerSatisfactionStar}
                              ></i>
                            ))}
                          </>
                        ) : (
                          <>
                            {Array.from({ length: 3 }, (_, i) => (
                              <i
                                className={`ti ti-star-filled star-3 icon-small fs-6`}
                                key={i}
                                // onClick={handleCustomerSatisfactionStar}
                              ></i>
                            ))}
                            <i
                              className={`ti ti-star-filled star-3 icon-small fs-6`}
                              // key={i}
                              //   onClick={handleCustomerSatisfactionStar}
                            ></i>
                            <i
                              className={`ti ti-star-filled star-3 icon-small fs-6`}
                              // key={i}
                              //   onClick={handleCustomerSatisfactionStar}
                            ></i>
                            <i
                              className={`ti ti-star-filled star-3 icon-small fs-6`}
                              // key={i}
                              //   onClick={handleCustomerSatisfactionStar}
                            ></i>
                          </>
                        )}
                      </span>
                    </button>
                  ),
                });
              });
            } else {
              rowsData.push({
                time: reason.updateDate,
                rating: reason.feedbackSatisfaction.reason,
              });
            }
          } catch (error) {
            console.error("Error parsing JSON:", error);
            rowsData.push({
              time: reason.updateDate,
              rating: reason.feedbackSatisfaction.reason,
              reason: (
                <button
                  type="button"
                  className="btn-rating after-rated py-1 lh-normal btn btn-secondary btn-sm m-0"
                >
                  <span>
                    {reason?.feedbackSatisfaction?.id < 10 ? (
                      <>
                        {Array.from(
                          { length: reason?.feedbackSatisfaction?.id },
                          (_, i) => (
                            <i
                              className={`ti ti-star-filled star-${reason?.feedbackSatisfaction?.id} icon-small fs-6`}
                              key={i}
                              //   onClick={handleCustomerSatisfactionStar}
                            ></i>
                          )
                        )}
                        {Array.from(
                          {
                            length: 5 - (reason?.feedbackSatisfaction?.id || 0),
                          },
                          (_, j) => (
                            <i
                              className={`ti ti-star-filled star-empty icon-small fs-6`}
                              key={j}
                              //   onClick={handleCustomerSatisfactionStar}
                            ></i>
                          )
                        )}
                      </>
                    ) : reason?.feedbackSatisfaction?.id === 100 ? (
                      <>
                        {Array.from({ length: 5 }, (_, i) => (
                          <i
                            className={`ti ti-star-filled star-5 icon-small fs-6`}
                            key={i}
                            // onClick={handleCustomerSatisfactionStar}
                          ></i>
                        ))}
                      </>
                    ) : (
                      <>
                        {Array.from({ length: 3 }, (_, i) => (
                          <i
                            className={`ti ti-star-filled star-3 icon-small fs-6`}
                            key={i}
                            // onClick={handleCustomerSatisfactionStar}
                          ></i>
                        ))}
                        <i
                          className={`ti ti-star-filled star-empty icon-small fs-6`}
                          // key={i}
                          //   onClick={handleCustomerSatisfactionStar}
                        ></i>{" "}
                        <i
                          className={`ti ti-star-filled star-empty icon-small fs-6`}
                          // key={i}
                          //   onClick={handleCustomerSatisfactionStar}
                        ></i>
                        {/* <i
                              className={`ti ti-star-filled star-empty icon-small fs-6`}
                              // key={i}
                            //   onClick={handleCustomerSatisfactionStar}
                            ></i> */}
                      </>
                    )}
                  </span>
                </button>
              ),
            });
          }
        } else {
        }
      } else {
      }
    });
  }, [reopenReasonList]);

  const tableStyles = {
    width: " 100%",
    height: "auto",
    minWidth: "0",
  };
  const rowsData = [];

  // reopenReasonList?.map((reason, index) => {
  //     debugger;
  //     rowsData.push({
  //         // resolverName: item.deSatisfactionReason,
  //         reason: <button type="button" className="btn-rating after-rated py-1 lh-normal btn btn-secondary btn-sm m-0">
  //             <span>
  //                 {Array.from({ length: reason?.feedbackSatisfaction?.id || 0 }, (_, i) => (
  //                     <i className={`ti ti-star-filled star-${reason?.feedbackSatisfaction?.id} icon-small fs-6`} key={i} ></i>
  //                 ))}
  //             </span>
  //         </button>
  //     })

  // });

  reopenReasonList?.map((reason, index1) => {
    if (reason?.updateDate && !reason.updateDate.toString().includes('/')) {
      const date = new Date(reason.updateDate); // works with timestamp or ISO string
      if (!isNaN(date)) {
        const pad = (n) => n.toString().padStart(2, '0');
        const formattedDate = `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
        reason.updateDate = formattedDate;
      }
    }
    if (
      reason?.feedbackSatisfaction?.reason !== null ||
      reason?.feedbackSatisfaction?.reason !== undefined
    ) {
      console.log(reason.feedbackSatisfaction.reason);
      console.log(reason.updateDate);
      // debugger;

      if (typeof reason.feedbackSatisfaction.reason === "string") {
        console.log(reason.feedbackSatisfaction.reason);
        try {
          console.log(reason.feedbackSatisfaction.reason);
          const parsedReason = JSON.parse(reason.feedbackSatisfaction.reason);
          console.log(parsedReason);
          const parsedTime = JSON.parse(reason.updateDate);
          console.log(parsedTime);
          debugger;
          if (Array.isArray(parsedReason)) {
            parsedReason.map((item, index) => {
              console.log(item);

              rowsData.push({
                time: item.updateDate,
                rating: item.deSatisfactionReason,
                reason: index === 0 && (
                  <button
                    type="button"
                    className="btn-rating after-rated py-1 lh-normal btn btn-secondary btn-sm m-0"
                  >
                    <span>
                      {reason?.feedbackSatisfaction?.id < 10 ? (
                        <>
                          {Array.from(
                            { length: reason?.feedbackSatisfaction?.id },
                            (_, i) => (
                              <i
                                className={`ti ti-star-filled star-${reason?.feedbackSatisfaction?.id} icon-small fs-6`}
                                key={i}
                                //   onClick={handleCustomerSatisfactionStar}
                              ></i>
                            )
                          )}
                          {Array.from(
                            {
                              length:
                                5 - (reason?.feedbackSatisfaction?.id || 0),
                            },
                            (_, j) => (
                              <i
                                className={`ti ti-star star-${reason?.feedbackSatisfaction?.id} icon-small fs-6`}
                                key={j}
                                //   onClick={handleCustomerSatisfactionStar}
                              ></i>
                            )
                          )}
                        </>
                      ) : reason?.feedbackSatisfaction?.id === 100 ? (
                        <>
                          {Array.from({ length: 5 }, (_, i) => (
                            <i
                              className={`ti ti-star-filled star-5 icon-small fs-6`}
                              key={i}
                              // onClick={handleCustomerSatisfactionStar}
                            ></i>
                          ))}
                        </>
                      ) : (
                        <>
                          {Array.from({ length: 3 }, (_, i) => (
                            <i
                              className={`ti ti-star-filled star-3 icon-small fs-6`}
                              key={i}
                              // onClick={handleCustomerSatisfactionStar}
                            ></i>
                          ))}
                          <i
                            className={`ti ti-star-filled star-3 icon-small fs-6`}
                            // key={i}
                            //   onClick={handleCustomerSatisfactionStar}
                          ></i>
                          <i
                            className={`ti ti-star-filled star-3 icon-small fs-6`}
                            // key={i}
                            //   onClick={handleCustomerSatisfactionStar}
                          ></i>
                          <i
                            className={`ti ti-star-filled star-3 icon-small fs-6`}
                            // key={i}
                            //   onClick={handleCustomerSatisfactionStar}
                          ></i>
                        </>
                      )}
                    </span>
                  </button>
                ),
              });
            });
          } else {
            rowsData.push({
              time: reason.updateDate,
              rating: reason.feedbackSatisfaction.reason,
              reason: (
                <button
                  type="button"
                  className="btn-rating after-rated py-1 lh-normal btn btn-secondary btn-sm m-0"
                >
                  <span>
                    {reason?.feedbackSatisfaction?.id < 10 ? (
                      <>
                        {Array.from(
                          { length: reason?.feedbackSatisfaction?.id },
                          (_, i) => (
                            <i
                              className={`ti ti-star-filled star-${reason?.feedbackSatisfaction?.id} icon-small fs-6`}
                              key={i}
                              //   onClick={handleCustomerSatisfactionStar}
                            ></i>
                          )
                        )}
                        {Array.from(
                          {
                            length: 5 - (reason?.feedbackSatisfaction?.id || 0),
                          },
                          (_, j) => (
                            <i
                              className={`ti ti-star-filled star-empty icon-small fs-6`}
                              key={j}
                              //   onClick={handleCustomerSatisfactionStar}
                            ></i>
                          )
                        )}
                      </>
                    ) : reason?.feedbackSatisfaction?.id === 100 ? (
                      <>
                        {Array.from({ length: 5 }, (_, i) => (
                          <i
                            className={`ti ti-star-filled star-5 icon-small fs-6`}
                            key={i}
                            // onClick={handleCustomerSatisfactionStar}
                          ></i>
                        ))}
                      </>
                    ) : (
                      <>
                        {Array.from({ length: 3 }, (_, i) => (
                          <i
                            className={`ti ti-star-filled star-3 icon-small fs-6`}
                            key={i}
                            // onClick={handleCustomerSatisfactionStar}
                          ></i>
                        ))}
                        <i
                          className={`ti ti-star-filled star-empty icon-small fs-6`}
                          // key={i}
                          //   onClick={handleCustomerSatisfactionStar}
                        ></i>{" "}
                        <i
                          className={`ti ti-star-filled star-empty icon-small fs-6`}
                          // key={i}
                          //   onClick={handleCustomerSatisfactionStar}
                        ></i>
                        {/* <i
                              className={`ti ti-star-filled star-empty icon-small fs-6`}
                              // key={i}
                            //   onClick={handleCustomerSatisfactionStar}
                            ></i> */}
                      </>
                    )}
                  </span>
                </button>
              ),
            });
          }
        } catch (error) {
          console.error("Error parsing JSON:", error);
          rowsData.push({
            time: reason.updateDate,
            rating: reason.feedbackSatisfaction.reason,
            reason: (
              <button
                type="button"
                className="btn-rating after-rated py-1 lh-normal btn btn-secondary btn-sm m-0"
              >
                <span>
                  {reason?.feedbackSatisfaction?.id < 10 ? (
                    <>
                      {Array.from(
                        { length: reason?.feedbackSatisfaction?.id },
                        (_, i) => (
                          <i
                            className={`ti ti-star-filled star-${reason?.feedbackSatisfaction?.id} icon-small fs-6`}
                            key={i}
                            //   onClick={handleCustomerSatisfactionStar}
                          ></i>
                        )
                      )}
                      {Array.from(
                        { length: 5 - (reason?.feedbackSatisfaction?.id || 0) },
                        (_, j) => (
                          <i
                            className={`ti ti-star-filled star-empty icon-small fs-6`}
                            key={j}
                            //   onClick={handleCustomerSatisfactionStar}
                          ></i>
                        )
                      )}
                    </>
                  ) : reason?.feedbackSatisfaction?.id === 100 ? (
                    <>
                      {Array.from({ length: 5 }, (_, i) => (
                        <i
                          className={`ti ti-star-filled star-5 icon-small fs-6`}
                          key={i}
                          // onClick={handleCustomerSatisfactionStar}
                        ></i>
                      ))}
                    </>
                  ) : (
                    <>
                      {Array.from({ length: 3 }, (_, i) => (
                        <i
                          className={`ti ti-star-filled star-3 icon-small fs-6`}
                          key={i}
                          // onClick={handleCustomerSatisfactionStar}
                        ></i>
                      ))}
                      <i
                        className={`ti ti-star-filled star-empty icon-small fs-6`}
                        // key={i}
                        //   onClick={handleCustomerSatisfactionStar}
                      ></i>{" "}
                      <i
                        className={`ti ti-star-filled star-empty icon-small fs-6`}
                        // key={i}
                        //   onClick={handleCustomerSatisfactionStar}
                      ></i>
                      {/* <i
                              className={`ti ti-star-filled star-empty icon-small fs-6`}
                              // key={i}
                            //   onClick={handleCustomerSatisfactionStar}
                            ></i> */}
                    </>
                  )}
                </span>
              </button>
            ),
          });
        }
      } else {
      }
    } else {
    }
  });

  // return (
  //     <>

  //         {reopenReasonList?.map((reason, index) => (
  //             <span key={index}>
  //                 {/* <button type="button" className="btn-rating after-rated py-1 lh-normal btn btn-secondary btn-sm m-0">
  //                 <span>
  //                     {Array.from({ length: reason?.feedbackSatisfaction?.id || 0 }, (_, i) => (
  //                         <i className={`ti ti-star-filled star-${reason?.feedbackSatisfaction?.id} icon-small fs-6`} key={i} ></i>
  //                     ))}
  //                 </span>
  //             </button> */}
  //                 {reason?.feedbackSatisfaction?.reason && (
  //                     <span>
  //                         <p>
  //                             {reason.feedbackSatisfaction.reason && (
  //                                 <span>
  //                                     {(() => {
  //                                         try {
  //                                             const jsonReason = JSON.parse(reason.feedbackSatisfaction.reason);
  //                                             if (Array.isArray(jsonReason)) {
  //                                                 return jsonReason.map((item, index) => (
  //                                                     <div key={index}>
  //                                                         <span>{item.deSatisfactionReason}</span>
  //                                                     </div>
  //                                                 ));
  //                                             } else {
  //                                                 // Handle the case where JSON is not an array
  //                                                 return <span>{jsonReason}</span>;
  //                                             }
  //                                         } catch (error) {
  //                                             // If parsing fails, treat it as a regular string
  //                                             return <span>{reason.feedbackSatisfaction.reason}</span>;
  //                                         }
  //                                     })()}
  //                                 </span>
  //                             )}
  //                         </p>
  //                     </span>
  //                 )}
  //             </span>
  //         ))}
  //     </>
  // )

  return (
    <Card className="overflow-hidden">
      <DatatTable
        tableStyles={tableStyles}
        tableData={{ columnData: columnData, rowsData: rowsData }}
      />
    </Card>
  );
}
